module.exports = __webpack_public_path__ + "static/media/accordionArrow.dbbd2f99.svg";